/**
 * 셀프가입 후 SYSTEM_ADMIN 승인 대기 안내 페이지 — Cycle 72.
 *
 * finalize 가 토큰을 발급하지 않고 'pending_approval' 응답 → Step4 가 본 페이지로 라우팅.
 * 가입자는 운영팀 승인 후 정식 로그인. (OnboardingExpiredPage 패턴 일관.)
 */

import { useSyncExternalStore } from 'react';
import { Link } from 'react-router-dom';
import { tOnb, getOnboardingLang, subscribeOnboardingLang } from '../../lib/onboarding-i18n';

export function OnboardingPendingApprovalPage() {
  useSyncExternalStore(subscribeOnboardingLang, getOnboardingLang, getOnboardingLang);
  return (
    <div role="status" aria-live="polite">
      <h2 className="onboarding-step__heading">{tOnb('onboarding.pending_approval.heading')}</h2>
      <p className="onboarding-step__subheading">
        {tOnb('onboarding.pending_approval.line1')}<br />
        {tOnb('onboarding.pending_approval.line2')}
      </p>
      <div className="onboarding-step__actions">
        <Link
          to="/login"
          className="onboarding-step__button onboarding-step__button--primary"
          style={{ textAlign: 'center', textDecoration: 'none', display: 'inline-block' }}
        >
          {tOnb('onboarding.btn.to_login')}
        </Link>
      </div>
    </div>
  );
}
